import {
  Directive,
  ElementRef,
  Output,
  EventEmitter,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';

@Directive({
  selector: '[changedVisibility]',
})
export class ChangedVisibilityDirective implements AfterViewInit, OnDestroy {
  @Output() changedVisibility: EventEmitter<boolean> = new EventEmitter();

  private intersectionObserver?: IntersectionObserver;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    this.intersectionObserver = new IntersectionObserver((entries) => {
      const entry = entries[0];
      this.changedVisibility.emit(entry.isIntersecting);
    });

    this.intersectionObserver.observe(this.el.nativeElement);
  }

  ngOnDestroy() {
    this.intersectionObserver?.disconnect();
  }
}
